const loggedInUser = state => state.loggedInUser;
export default {
  inMaintenanceMode: state => state.inMaintenanceMode,
  settedLang: state => state.lang,
  currentPage: state => state.pageHistory[state.pageHistory.length - 1].pageName,
  currentPageData: state => state.pageHistory[state.pageHistory.length - 1].pageData,
  currentOverlay: state => state.currentOverlay.overlayName,
  currentOverlayData: state => state.currentOverlay.overlayData,
  currentPageCategory(state, getters) {
    const currentPageName = getters.currentPage;
    if (currentPageName.startsWith('Tickets')) return 'Tickets';
    else if (currentPageName.startsWith('Transaction')) return 'Tickets';
    else if (currentPageName.startsWith('Booking')) return 'Tickets';
    else if (currentPageName.startsWith('Checkout')) return 'Tickets';
    else if (currentPageName.startsWith('Benefits')) return 'Benefits';
    else if (currentPageName.startsWith('Profile')) return 'Profile';
    else if (currentPageName.startsWith('Register')) return 'Profile';
    else if (currentPageName.startsWith('Login')) return 'Profile';
    else if (currentPageName.startsWith('More')) return 'More';
    else return 'Start';
  },
  currentLocation(state) {
    if (!state.communes || !state.communes.length) return { id: -1, name: 'Kommune auswählen' };
    return state.communes.length
      ? state.communes.find(commune => commune.id === state.communeSelected)
      : { id: 0, name: 'Keine Kommune ausgewählt' };
  },
  locations: state => state.communes,
  communeInfo: state => state.communeInfo,
  strictAccommodationSelection: state => state.communeInfo.strictAccommodationSelection,
  loggedInUser,
  translationsLoaded: state => state.translationsLoaded,
  userLoaded: state => state.userLoaded,
  savedPeople: state => state.savedUser,
  favorites: state => state.favorites,
  preferences: state => state.preferences,
  preferencesByCategory: state => category => state.preferences.filter(pref => pref.prefCategory === category),
  benefitCategories: state => state.benefitCategories,
  benefitCategoryData: state => categoryId => state.benefitCategories.filter(benefit => benefit.id === categoryId), //Used in previous version of Advantages
  benefitCategoryByNameData: state => (categoryName, scopeSelected) => state.benefitCategories.filter((benefitCategory) => {
    return benefitCategory.name === categoryName && (scopeSelected == "all" || scopeSelected == benefitCategory.benefitCommuneId);
  }),
  benefitsOfCategory: state => (categoryName, scopeSelected) => state.benefits.filter((benefit) => {
    return benefit.category_name === categoryName && (scopeSelected == 'all' || scopeSelected == benefit.benefitCommuneId);
  }),
  benefitsDetail: state => benefitId => state.benefits.filter(benefit => benefit.id === benefitId)[0],
  benefits: state => state.benefits,
  benefitsOfFavorites: state => {
    if (!state.favorites) {
      return [];
    }

    return state.favorites.filter(bf => bf.venueCommuneId === state.communeSelected);
  },
  benefitsOfPreferences: state => {
    if (!state.benefits || !state.preferences) {
      return [];
    }
    return state.benefits.filter(b =>
      state.preferences.some(p => b.benefitPreferences.includes(p.prefId) && p.prefChecked)
    );
  },
  // ticketBooking: state => state.ticketBooking,
  communeSelected: state => state.communeSelected,
  hasValidTicket: state => state.validTickets > 0,
  manuallyDefinedSpecialConditions: state => state.manuallyDefinedSpecialConditions, 
  availableLocales(_state) {
    return [
      { key: 'de', value: 'Deutsch', translationPath: 'more.language.german' },
      { key: 'en', value: 'English', translationPath: 'more.language.english' },
      { key: 'fr', value: 'Français', translationPath: 'more.language.french' },
      { key: 'dk', value: 'Danish', translationPath: 'more.language.danish' },
      { key: 'it', value: 'Italiano', translationPath: 'more.language.italian' },
      { key: 'es', value: 'Español', translationPath: 'more.language.spanish' },
      { key: 'nl', value: 'Niederländisch', translationPath: 'more.language.dutch' },
      { key: 'cz', value: 'Tschechisch', translationPath: 'more.language.czech' },
    ];
  },
};
